import {Board, BoardIdentifier} from '../boardModel';

import * as environment from '../../../environments/environment';
import {UserSettings} from "./userSettings";
const be_url = environment.environment.backend_proto + "://" + environment.environment.backend_host + ":" + environment.environment.backend_port + environment.environment.backend_path;

/**
 user_id: number = -1;
 user_name: string = "default_user_name";
 user_avatar: string = <backend_host_via_setting> + "/images/default/dummy.png";
 user_email: string = "default_email";
 user_homepage: string = "default_homepage";
 user_country: string = "default_country";
 user_city: string = "default_city";
 user_zip: string = "default_zip";
 user_status: string = "default_status";
 user_settings: UserSettings = new UserSettings();

 */
export class User {
    user_id: number = -1;
    user_name: string = "";
    user_avatar: string = "assets/images/no_image.svg";
    user_email: string = "";
    user_homepage: string = "";
    user_country: string = "";
    user_city: string = "";
    user_zip: string = "";
    user_status: string = "";
    user_facebook: string = "";
    user_twitter: string = "";
    user_tumblr: string = "";
    user_soundcloud: string = "";
    user_twitch: string = "";
    user_youtube: string = "";
    user_instagram: string = "";
    user_pinterest: string = "";
    user_is_verified: number = 0;

    user_settings: UserSettings = new UserSettings();
    constructor(user_id?:number, user_name?:string, user_avatar?: string, user_is_verified?:number, user_email?:string, user_homepage?: string, user_country?: string, user_city?:string, user_zip?:string, user_status?:string, user_settings?:UserSettings){
        if(user_id != null){ this.user_id = user_id; }
        if(user_name != null){ this.user_name = user_name; }
        if(user_email != null){ this.user_email = user_email; }
        if(user_avatar != null){ this.user_avatar = user_avatar; }
        if(user_is_verified != null){ this.user_is_verified = user_is_verified; }
        if(user_homepage != null){ this.user_homepage = user_homepage; }
        if(user_country != null){ this.user_country = user_country; }
        if(user_city != null){ this.user_city = user_city; }
        if(user_zip != null){ this.user_zip = user_zip; }
        if(user_status != null){ this.user_status = user_status; }
        if(user_settings != null){ this.user_settings = user_settings; }
    }
    // constructor(user:User){
    //     this.user_id=user.user_id;
    //     this.user_name=user.user_name;
    //     this.user_email=user.user_email;
    //     this.user_avatar=user.user_avatar;
    //     this.user_homepage=user.user_homepage;
    //     this.user_country=user.user_country;
    //     this.user_city=user.user_city;
    //     this.user_zip=user.user_zip;
    //     this.user_status=user.user_status;
    // }
}

export class UserIdentifier {
    user_id: number = -1;
}

export class Owner extends User {
    owner_of_boards: BoardIdentifier[] = [];
    // constructor(user_id:number, user_name:string, user_avatar: string, user_email?:string, user_homepage?: string, user_country?: string, user_city?:string, user_zip?:string, user_status?:string, owned_board_id_list?:BoardIdentifier[]){
    //     super(user_id, user_name, user_email, user_avatar, user_homepage, user_country, user_city, user_zip, user_status);
    //     this.owner_of_boards = owned_board_id_list;
    //}
    constructor(owner:User, owned_board_id_list:BoardIdentifier[]){
        super(owner.user_id,owner.user_name, owner.user_avatar, owner.user_is_verified, owner.user_email, owner.user_homepage, owner.user_country, owner.user_city, owner.user_zip, owner.user_status);
        this.owner_of_boards=owned_board_id_list;
    }
}

export class GetCurrentUserResponse{
    auth: {
        token: UserToken,
    };
    data: User;
}

export class UserToken{
    token:string ="";
    ttl:number = -1;
    lifeTime: number =-1;
    isCurrentlyValidToken: boolean = false;
}


export class Friends{
    user_id: number;
    user_name: string;
    user_avatar: string;
    message: string;
    relation_status: number;
    created_at: Date;
    modifieds_at: Date;
    constructor(user_id?:number,user_name?:string,user_avatar?:string,message?:string,relation_status?:number,created_at?:Date,modifieds_at?:Date, ) {
        this.user_id = user_id;
        this.user_name = user_name;
        this.user_avatar = user_avatar;
        this.message = message;
        this.relation_status = relation_status;
        this.created_at = created_at;
        this.modifieds_at = modifieds_at;

    }
}

export class Awards{
    award_id: number;
    award_icon: string;
    award_description: string;
    award_translate: string;
    description_user_page: string;
}

export class AwardInfo {
    user_id: number;
    user_name: string;
    user_avatar: string;
    count: number;
    board_id: number;
    board_name: string;
    board_avatar: string;
    constructor(user_id?:number,user_name?:string,user_avatar?:string,count?:number,board_id?:number,board_name?:string,board_avatar?:string ) {
        this.user_id = user_id;
        this.user_name = user_name;
        this.user_avatar = user_avatar;
        this.count = count;
        this.board_id = board_id;
        this.board_name = board_name;
        this.board_avatar = board_avatar;
    }
}
